<template>
  <div>
    <a-row type="flex" class="area-header">
      <h1 class="title">Models</h1>
      <a-button type="primary" @click="$router.push('/admin/projects/new')">Create new</a-button>
    </a-row>

    <a-table
      :columns="columns"
      :dataSource="projectsArray"
      style="width: 100%"
      :rowKey="record => record.id"
    >
      <div slot="action" slot-scope="record">
        <a-button size="small" @click="$router.push(`/admin/projects/${record.id}`);">Edit</a-button>
        <a-button size="small" type="danger" @click="onDeleteProject(record.id)">Delete</a-button>
      </div>
    </a-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Projects",
  data() {
    return {
      dialogVisible: {
        project: false
      },

      columns: [
        {
          title: "Name",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "Action",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    onDeleteProject(id) {
      this.$store.dispatch("project/delete", id);
    }
  },
  async created() {
    this.$store.commit("SET_IS_FETCHING", true);
    await this.$store.dispatch("project/fetchAll");
    this.$store.commit("SET_IS_FETCHING", false);
  },
  computed: {
    ...mapGetters("project", {
      projectsArray: "asArray"
    })
  }
};
</script>
